import React from 'react';
import { connect } from 'react-redux';
import { getModal } from '../store/presentationSelector';
import { setModal } from '../store/presentationActions';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const Modal = (props) => {
    const { modal, setNewModalState } = props;
    const { opened } = modal;

    const handleClose = () => {
        setNewModalState({
            ...modal,
            opened: false,
        });
    };

    return (
        <Dialog
            open={opened}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Use Google's location service?
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Let Google help apps determine location. This means sending
                    anonymous location data to Google, even when no apps are
                    running.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Disagree
                </Button>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Agree
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        modal: getModal(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setNewModalState: (newModalState) => dispatch(setModal(newModalState)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
